<lib-app-update-banner />

<div
  [class.theme-vendor]="isVendor() && isOnVendorPortal()"
  class="app-screen-warning hidden h-[calc(100vh-4.75rem)] fixed inset-x-0 z-[-1]">
  <lib-not-supported-screen />
</div>

@if (!sideMenuShown()) {
  <lib-navbar
    [navClass]="
      !showNavbar()
        ? 'absolute bg-transparent z-10'
        : 'bg-white' + (isVendor() && isOnVendorPortal() ? ' theme-vendor' : '')
    "
    [showNotification]="isLoggedIn() && !isOnVendorPortal()" />
}
<div class="app-content relative">
  <lib-maintenance-mode />
  <lib-site-redirect-notice />

  <main
    [class]="
      'w-full overflow-y-auto relative z-0 ' +
      (showNavbar() && !sideMenuShown()
        ? 'max-h-[calc(100vh-4.75rem)]'
        : 'h-full')
    ">
    <router-outlet />
  </main>

  @if (showToast()) {
    <lib-alert-inline
      [alertData]="toastData().alertData"
      [hasCloseIcon]="toastData().hasCloseIcon"
      [hasIcon]="toastData().hasIcon"
      (handleAlertClose)="onCloseToast($event)"
      class="absolute top-10 end-5" />
  }
</div>
